import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { FootballEnableNotificationsPrompt } from './Football.tsx';
import { NBAEnableNotificationsPrompt } from './NBA.tsx';

type Props = {
  open: boolean;
  onNext: () => void;
};

export const EnableNotificationsPrompt = ({ open, onNext }: Props) => {
  const { sport } = useSportContext();

  if (sport === Sport.NBA) {
    return <NBAEnableNotificationsPrompt open={open} onClose={onNext} />;
  }
  // Default to Football
  return <FootballEnableNotificationsPrompt open={open} onNext={onNext} />;
};
